import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  Link,
} from "@material-ui/core";
import React from "react";
import { KeyboardArrowRight } from "@material-ui/icons";

export function Finance(props) {
  const { data } = props;
  const preventDefault = (event) => event.preventDefault();

  const financeData = {
    avgCostOfAttendance: {
      title: "AVG Cost Of Attendance",
      value: data.avgCostOfAttendance,
    },
    avgNetPrice: {
      title: "AVG Net Price",
      value: data.avgNetPrice,
    },
    financialAidWebsite: {
      title: "Financial Aid Website",
      value: data.financialAidWebsite,
    },
    inStateTuition: {
      title: "In State Tuition",
      value: data.inStateTuition,
    },
  };

  return (
    <Card className="pt-5 px-5">
      <CardHeader title="Finance"></CardHeader>
      <CardContent>
        <Grid container spacing={5}>
          <Grid item sm>
            <Box>
              <List>
                {["avgCostOfAttendance", "avgNetPrice", "inStateTuition"].map(
                  (keyName, index) => (
                    <Box key={index}>
                      <ListItem>
                        <ListItemText>
                          <Typography>{financeData[keyName].title}</Typography>
                        </ListItemText>
                        <ListItemSecondaryAction>
                          <Typography>
                            {financeData[keyName].value
                              ? financeData[keyName].value
                              : "--"}
                          </Typography>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider />
                    </Box>
                  )
                )}
                <ListItem key={3}>
                  <ListItemText>
                    <Typography>
                      {financeData["financialAidWebsite"].title}
                    </Typography>
                  </ListItemText>
                  <ListItemSecondaryAction>
                    <Typography>
                      <a
                        href={
                          financeData["financialAidWebsite"].value
                            ? "https://" +
                              financeData["financialAidWebsite"].value
                            : "#"
                        }
                      >
                        {financeData["financialAidWebsite"].value
                          ? "Click Here"
                          : "--"}
                      </a>
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider />
              </List>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
      <hr className="mb-0" />
      <CardActions>
        <Typography variant="body1" color="primary" className="ml-auto mr-2">
        <Link
            href={window.location.href + "/finance"}
            onLClick={preventDefault}
          >
          Read More about Finance <KeyboardArrowRight />
          </Link>
        </Typography>
      </CardActions>
    </Card>
  );
}
